// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"598":"27cef5ef","703":"34b01201","787":"d985731b"}[chunkId] + ".chunk.js";
};